<template>
  <section id="femaleVideos" class="mt-5">
    <div class="box--wrapper">
      <div class="container">
        <div v-for="section in sections" :key="section.type" class="slideWrapper">
          <female-videos-slider :entries="section.entries" :section="section" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  const sections = require('../videos.json')
  export default ({
    setup() {
      return {
        sections
      }
    },
  })
</script>